export default "__VITE_ASSET__DiXpulCN__"